<template>
  <SearchHour></SearchHour>
</template>

<script>
// @ is an alias to /src
import SearchHour from "@/components/SearchHour.vue";
export default {
  name: "SearchHourView",
  components: { SearchHour }
};
</script>
